module.exports = __webpack_public_path__ + "img/6f.674dc3b5.png";